module.exports = __webpack_public_path__ + "media/images/motto-bg3-320-895cf82e6c80cbbd98b7a49801490bed.png";